import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../app/store";

export interface BookingDetailState {
  data: [] | null | any;
  totalPages: number | null;
  currentPage: number | null;
  totalRecords: number | null;
}

const initialState: BookingDetailState = {
  data: null,
  totalPages: null,
  currentPage: null,
  totalRecords: null,
};

export const bookingSlice = createSlice({
  name: "bookings",
  initialState,
  reducers: {
    setBookingDetail: (state, action) => {
      state.data = action.payload.data;
      state.totalPages = action.payload.totalPages;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    addBookingDetail: (state: any, action) => {
      state.data = action.payload;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setBookingDetail, addBookingDetail, reset } =bookingSlice.actions;
export const getBookingDetails = (state: RootState) => state.bookings.data;
export const getTotalRecord = (state: RootState) => state.bookings.totalRecords;
export const getTotalPage = (state: RootState) => state.bookings.totalPages;

export default bookingSlice.reducer;
